/** @file Pixel joint and tip of one bone: world origin and origin + length along its world X axis. */
import { POSE_LAYOUT } from '@pose2d/core/contracts/pose';
import type { Pose } from '@pose2d/core/types';
import type { Camera } from '@pose2d/geometry/types';
import { affine } from '@pose2d/math/affine';

const p: [number, number] = [0, 0];

/** Writes [jointX, jointY, tipX, tipY] in pixels into out; a bone missing from `pose` yields NaN. */
export function boneSegment(pose: Pose, camera: Camera, bone: number, length: number, out: Float64Array): Float64Array {
  const o = bone * POSE_LAYOUT.WORLD_STRIDE, w = pose.world;
  const a = w[o] ?? NaN, c = w[o + 2] ?? NaN, x = w[o + 4] ?? NaN, y = w[o + 5] ?? NaN;
  affine.apply(camera.worldToPixel, x, y, p);
  out[0] = p[0];
  out[1] = p[1];
  affine.apply(camera.worldToPixel, x + a * length, y + c * length, p);
  out[2] = p[0];
  out[3] = p[1];
  return out;
}
